import { createFileRoute } from "@tanstack/react-router";
import { AgentWorkflowPage } from "@/components/agent-cli-pages";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/agent/review-social-queue";
export const Route = createFileRoute(path)({
	component: () => <AgentWorkflowPage slug="review-social-queue" />,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "Review Your Social Queue with an AI Agent",
			description:
				"Find repeated angles, missing media, invalid settings, weak hooks, and timing collisions before posts go live.",
		}),
});
